<input class="form-control"
       [class.form-control-sm]="small"
       (change)="handleDateChange($event)"
       id="{{ id }}"
       name="{{ id }}"
       [placeholder]="placeholder"
       [disabled]="disabled"
       [class.disabled]="disabled">

<div *ngIf="containerIdOverride === ''"
     [id]="datePickerContainerId"
     class="air-datepicker-global-container"></div>
